import { useForm } from "@inertiajs/react"
import { useEffect } from "react"
import { Loader2, Users } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogDescription,
  ResponsiveDialogFooter,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
} from "@/components/ui/responsive-dialog"

// Coach self-service group creation — used both for a groupless coach's
// first group (Dashboard empty state) and for an existing coach spinning up
// an additional one (CoachGroupSwitcher "+ New group"). Name only; the
// server defaults everything else (POST /app/coach/group).
export function CreateGroupDialog({ open, onOpenChange }) {
  const form = useForm({ name: "" })

  useEffect(() => {
    if (open) {
      form.reset()
      form.clearErrors()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const handleSubmit = (e) => {
    e.preventDefault()
    form.post("/app/coach/group", {
      preserveScroll: true,
      onSuccess: () => onOpenChange(false),
    })
  }

  return (
    <ResponsiveDialog open={open} onOpenChange={onOpenChange}>
      <ResponsiveDialogContent>
        <ResponsiveDialogHeader>
          <ResponsiveDialogTitle>Create a group</ResponsiveDialogTitle>
          <ResponsiveDialogDescription>
            You'll become this group's coach right away.
          </ResponsiveDialogDescription>
        </ResponsiveDialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 px-4 md:px-0">
          <div className="space-y-1.5">
            <Label htmlFor="new-group-name">Group name</Label>
            <Input
              id="new-group-name"
              value={form.data.name}
              onChange={(e) => form.setData("name", e.target.value)}
              placeholder="e.g. Tuesday Morning Cohort"
              autoFocus
            />
          </div>

          <ResponsiveDialogFooter>
            <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="gradient"
              disabled={form.processing || !form.data.name.trim()}
            >
              {form.processing ? (
                <Loader2 className="h-4 w-4 animate-spin mr-1.5" />
              ) : (
                <Users className="h-4 w-4 mr-1.5" />
              )}
              Create Group
            </Button>
          </ResponsiveDialogFooter>
        </form>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  )
}
